import {Breadcrumbs, styled, Typography} from '@mui/material';
import {StyledTypographyType} from './types';

const StyledBreadcrumbs = styled(Breadcrumbs)`
	.MuiBreadcrumbs-separator {
		color: ${({theme}) => theme.colors.brand.primary.white};
	}
`;

const StyledTypography = styled(Typography, {
	shouldForwardProp: prop => prop !== 'isLast',
})<StyledTypographyType>`
	color: ${({theme}) => theme.colors.brand.primary.white};
	font-size: 14px;
	font-weight: 400;
	letter-spacing: 0.17px;
	text-decoration: ${({isLast}) => (isLast ? undefined : 'underline')};
	cursor: ${({isLast}) => (isLast ? undefined : 'pointer')};
`;

export {StyledTypography, StyledBreadcrumbs};
